import React from 'react'
import { GridContainer, GridItem } from '@entur/grid'
import { SubLabel } from '@entur/typography'
import { colors, space } from '@entur/tokens'
import { Period } from '../travel-tab'
import { getNumberOfSavingDaysInMonth, savingPrintFormat } from '../savings-calculations'
import CopyButton from '../../copy-button/copy-button'

type TicketDetailProps = {
  label: string
  detail: string
  subDetail?: string
  copyable?: boolean
}

const TicketDetail: React.FC<TicketDetailProps> = ({ label, detail, subDetail, copyable = false }) => {
  return (
    <GridItem small={6} medium={3}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <SubLabel>{label}</SubLabel>
        <p style={{ margin: 0 }}>
          {detail}
          {subDetail && <span style={{ color: colors.blues.blue30 }}>{subDetail}</span>}
          {copyable && <CopyButton value={detail} description={label} />}
        </p>
      </div>
    </GridItem>
  )
}

type TicketDetailsProps = {
  travellerName: string
  ticketReference: string
  monthlySaving: string
  calculatedPeriod: Period
  totalTravelDaysForTicket: number
  totalSavingForTicket: string
  isNotDistributed: boolean
}

export const TicketDetails: React.FC<TicketDetailsProps> = ({
  travellerName,
  ticketReference,
  monthlySaving,
  calculatedPeriod,
  totalTravelDaysForTicket,
  totalSavingForTicket,
  isNotDistributed,
}) => {
  const numberOfSavingDaysInMonth = getNumberOfSavingDaysInMonth(calculatedPeriod)

  return (
    <GridContainer style={{ paddingTop: space.default }} spacing="medium">
      {isNotDistributed ? (
        <>
          <TicketDetail label="Reisedager" detail={`${totalTravelDaysForTicket}`} />
          <TicketDetail label="Besparelse" detail={`${savingPrintFormat(totalSavingForTicket)}`} />
        </>
      ) : (
        <>
          <TicketDetail
            label="Reisedager i måned"
            detail={`${numberOfSavingDaysInMonth}`}
            subDetail={` (av ${totalTravelDaysForTicket})`}
          />
          <TicketDetail
            label="Delsum i måned"
            detail={`${savingPrintFormat(monthlySaving)}`}
            subDetail={` (av ${savingPrintFormat(totalSavingForTicket)})`}
          />
        </>
      )}
      <TicketDetail label="Reisende" detail={travellerName} copyable />
      <TicketDetail label="Referanse" detail={ticketReference} copyable />
    </GridContainer>
  )
}
